<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <v-row
        justify="center"
      >
        <v-col
          class="center"
          cols="12"
          lg="8"
        >
          <h2
            class="colorPrimary text-center"
          >
            Muziek uitvaart
          </h2>
          <p
            class="text-center"
          >
            We voorzien vijf muziekstukken waarvan eentje bij aanvang en eentje op het einde.
            <br>
            U kan kiezen uit een uitgebreide collectie van muzieknummers,
            <br>
            maar indien gewenst kan u ook persoonlijk gekozen muziekfragmenten toevoegen.
            <br>
            Wijzigingen via uw persoonlijke account kunnen tot 24 uur voor de uitvaart.
          </p>
        </v-col>
        <v-col
          class="center mt-5"
          cols="12"
          lg="6"
        >
          <v-row
            justify="center"
          >
            <v-col
              cols="12"
              lg="7"
            >
              <v-row>
                <v-col
                  v-for="(muziekType, index) in lists.muziekType"
                  class="px-1"
                  :key="index"
                >
                  <v-btn
                    block
                    class="mb-1"
                    :color="selectedMuziekType.includes(muziekType.value) ? 'secondary' : '#C6C9CC'"
                    height="40"
                    tile
                    @click="SelectMuziekType(muziekType.value)"
                  >
                    {{ muziekType.longDescription }}
                  </v-btn>
                </v-col>
                <v-col
                  class="px-1"
                  cols="12"
                  lg="4"
                >
                  <v-text-field
                    v-model="search"
                    append-inner-icon="mdi-magnify"
                    clearable
                    :color="Muziek.length === 0 && search ? 'error' : 'primary'"
                    density="compact"
                    label="Zoeken"
                    variant="outlined"
                  />
                </v-col>
                <v-col
                  class="px-1"
                  cols="12"
                  lg="1"
                >
                </v-col>
              </v-row>
              <v-row
                v-if="current.idMuziek"
                justify="center"
              >
                <v-col
                  class="text-center"
                  cols="12"
                  lg="11"
                >
                  <control-music
                    :title="Title(current)"
                    :modelValue="current.src"
                  />
                </v-col>
              </v-row>
              <v-row
                v-if="PageList.length === 0"
                justify="center"
              >
                <v-col
                  class="font-italic my-8 py-8 text-center"
                  cols="12"
                  lg="8"
                >
                  Er is momenteel geen muziek die binnen uw zoekcriteria valt.
                </v-col>
              </v-row>
              <v-pagination
                v-if="PageCount > 1"
                v-model="page"
                class="mt-3"
                color="primary"
                :length="PageCount"
              />
              <div
                class="my-8"
              >
                <v-row
                  v-for="(lied, index) in PageList"
                  class="my-1 py-0"
                  :key="index"
                >
                  <v-col
                    :class="current === lied ? 'activeRow' : index % 2 === 0 ? 'alternatingContentRow2' : ''"
                    cols="12"
                    lg="11"
                  >
                    <v-icon
                      class="clickAction mr-2"
                      color="black"
                      @click="SelectCurrent(lied)"
                    >
                      mdi-{{ current === lied ? 'volume-low' : 'play'}}
                    </v-icon>
                    {{ Title(lied) }}
                  </v-col>
                  <v-col
                    cols="12"
                    lg="1"
                  >
                    <v-checkbox
                      :modelValue="data.keuze.some(x => x.idMuziek === lied.idMuziek)"
                      base-color="secondary"
                      bg-color="white"
                      class="float-right"
                      color="primary"
                      density="compact"
                      :disabled="data.geblokkeerd || (data.keuze.length >= maxKeuze && !data.keuze.map(x => x.idMuziek).includes(lied.idMuziek))"
                      hide-details
                      @update:modelValue="MuziekSelectChange(lied)"
                    />
                  </v-col>
                </v-row>
              </div>
              <v-pagination
                v-if="PageCount > 1"
                v-model="page"
                color="primary"
                :length="PageCount"
              />
            </v-col>
            <v-col
              cols="12"
              lg="1"
            >
            </v-col>
            <v-col
              cols="12"
              lg="4"
            >
              <v-row
                class="borderedContainerPrimary px-3 py-1"
              >
                <v-col
                  class="borderedContainerPrimaryTitle py-1"
                  cols="12"
                  lg="12"
                >
                  Mijn muziekkeuze (Max. {{ maxKeuze }})
                </v-col>
                <v-col
                  cols="12"
                  lg="12"
                >
                  <template
                    v-if="data.keuze.length === 0"
                  >
                    <v-row
                      :class="data.geblokkeerd ? '' : 'borderedContainerDivisionLine'"
                      justify="center"
                    >
                      <v-col
                        class="font-italic my-8 py-8 text-center"
                        cols="12"
                        lg="12"
                      >
                        U heeft nog geen muzieknummers geselecteerd.
                      </v-col>
                    </v-row>
                  </template>
                  <template
                    v-else
                  >
                    <v-row
                      v-for="(lied, index) in data.keuze"
                      :class="index < data.keuze.length - 1 || MuziekEigenNummerToevoegenTonen ? 'borderedContainerDivisionLine' : ''"
                      :key="index"
                    >
                      <v-col
                        cols="12"
                        lg="1"
                      >
                        {{ index + 1 }}
                      </v-col>
                      <v-col
                        cols="12"
                        lg="1"
                      >
                        <v-btn
                          v-if="index > 0"
                          class="smallButton"
                          color="primary"
                          :disabled="data.geblokkeerd"
                          size="x-small"
                          variant="outlined"
                          @click="MuziekMoveUp(index)"
                        >
                          <v-icon
                            class="mt-1"
                          >
                            mdi-chevron-up
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="index < data.keuze.length - 1"
                          class="smallButton"
                          color="primary"
                          :disabled="data.geblokkeerd"
                          size="x-small"
                          variant="outlined"
                          @click="MuziekMoveDown(index)"
                        >
                          <v-icon
                            class="mt-1"
                          >
                            mdi-chevron-down
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="9"
                      >
                        <template
                          v-if="lied.idMuziek || data.geblokkeerd"
                        >
                          <i>
                            {{ lists.muziekType.find(x => x.value === lied.muziekType)?.longDescription }}
                          </i>
                          <br>
                          {{ lied.titel }}
                          <br>
                          {{ lied.artiest }}
                        </template>
                        <template
                          v-else
                        >
                          <control-select
                            v-model="lied.muziekType"
                            dense
                            :disabled="data.geblokkeerd"
                            itemValue="value"
                            itemText="longDescription"
                            :items="lists.muziekType"
                            label="Type"
                            outlined
                            required
                            :requiredText="textMixin.messages.required"
                          />
                          <v-text-field
                            v-model="lied.titel"
                            base-color="primary"
                            bg-color="white"
                            color="primary"
                            density="compact"
                            :disabled="data.geblokkeerd"
                            label="Titel"
                            variant="outlined"
                            :rules="[validationMixin.rules.max50Characters, validationMixin.rules.required]"
                          />
                          <v-text-field
                            v-model="lied.artiest"
                            base-color="primary"
                            bg-color="white"
                            color="primary"
                            density="compact"
                            :disabled="data.geblokkeerd"
                            label="Artiest"
                            variant="outlined"
                            :rules="[validationMixin.rules.max50Characters, validationMixin.rules.required]"
                          />
                        </template>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="1"
                      >
                        <v-btn
                          class="smallButton"
                          color="primary"
                          :disabled="data.geblokkeerd"
                          size="x-small"
                          variant="outlined"
                          @click="data.keuze.splice(index, 1)"
                        >
                          <v-icon
                            class="mt-1"
                          >
                            mdi-close
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </template>
                  <a
                    v-if="MuziekEigenNummerToevoegenTonen"
                    @click="MuziekEigenNummerToevoegen()"
                  >
                    + Eigen nummer toevoegen
                  </a>
                </v-col>
              </v-row>
              <v-row
                class="px-0 py-1"
              >
                <v-col
                  class="px-0"
                  cols="12"
                  lg="12"
                >
                  <v-textarea
                    v-model="data.opmerking"
                    auto-grow
                    base-color="primary"
                    bg-color="white"
                    color="primary"
                    density="compact"
                    :disabled="data.geblokkeerd"
                    label="Opmerking"
                    placeholder="Plaats hier eventuele extra opmerkingen: bv. wanneer een liedje op een welbepaald moment in de uitvaart aan bod mag komen."
                    variant="outlined"
                  />
                  <v-btn
                    v-if="!data.geblokkeerd"
                    block
                    color="primary"
                    :disabled="data.geblokkeerd"
                    tile
                    @click="Save()"
                  >
                    Muziek opslaan
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import validationMixin from '@/mixins/validationMixin' 
import blobService from '@/services/blobService'
import listMixin from '@/mixins/listMixin'
import klantService from '@/services/klantService'
import ControlMusic from './ControlMusic.vue'
import ControlSelect from './ControlSelect.vue'

export default {
  name: 'MuziekComponent',
  mixins: [
    authenticationMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    listMixin,
    validationMixin
  ],
  components: {
    ControlMusic,
    ControlSelect
  },
  data () {
    return {
      current: {},
      data: {
        geblokkeerd: false,
        keuze: [],
        opmerking: null
      },
      lists: {
        code: [],
        muziekType: []
      },
      maxKeuze: 5,
      numberPerPage: 20,
      page: 1,
      search: '',
      selectedMuziekType: [],
      valid: false
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    blobService.Init(this)
    klantService.Init(this)
    this.GetUitvaartMuziek()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  watch: {
    PageCount (value) {
      if (this.page > value) {
        this.page = value
      }
    }
  },
  computed: {
    Muziek () {
      let list = this.listMixin.list
      list = list.filter(x => this.selectedMuziekType.includes(x.muziekType))

      if (this.search) {
        list = list.filter(x => x.artiest.toLowerCase().includes(this.search.toLowerCase()) || x.titel.toLowerCase().includes(this.search.toLowerCase()))
      }

      return list
    },
    MuziekEigenNummerToevoegenTonen () {
      return !this.data.geblokkeerd && this.data.keuze.length < this.maxKeuze
    },
    PageList () {
      return this.CommonMixin_GetPageList(this.Muziek, this.page, this.numberPerPage)
    },
    PageCount () {
      return this.CommonMixin_GetPageCount(this.Muziek, this.numberPerPage)
    }
  },
  methods: {
    async GetBlobMuziek (idBlob) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await blobService.GetBase64(idBlob)
      this.CommonMixin_Load(this.$options.name, false)

      if (resp && (resp.data || resp.data !== '')) {
        return this.CommonMixin_Clone(resp.data)
      } else {
        return null
      }
    },
    async GetUitvaartMuziek () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartMuziek()

      if (resp && (resp.data || resp.data !== '')) {
        this.data = this.CommonMixin_Clone(resp.data)
      }

      await this.GetUitvaartMuziekLists()
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetUitvaartMuziekListCode () {
      const resp = await klantService.GetUitvaartMuziekListCode()

      if (resp?.data) {
        this.lists.code = resp.data
        this.lists.muziekType = this.CommonMixin_GetElementsByPropertyValue(resp.data, 'type', this.constantMixin.codes.muziekType.name)
        this.selectedMuziekType = this.lists.muziekType.map(x => x.value)
      }
    },
    async GetUitvaartMuziekListMuziek () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartMuziekListMuziek()

      if (resp && (resp.data || resp.data !== '')) {
        this.listMixin.list = resp.data
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetUitvaartMuziekLists () {
      await this.GetUitvaartMuziekListMuziek()
      await this.GetUitvaartMuziekListCode()
    },
    MuziekEigenNummerToevoegen () {
      this.data.keuze.push({
        artiest: '',
        titel: '',
      })
    },
    MuziekMoveDown (index) {
      if (index < this.data.keuze.length - 1) {
        const updatedKeuze = [...this.data.keuze];
        [updatedKeuze[index], updatedKeuze[index + 1]] = [updatedKeuze[index + 1], updatedKeuze[index]];
        this.data.keuze = updatedKeuze;
      }
    },
    MuziekMoveUp (index) {
      if (index > 0) {
        const updatedKeuze = [...this.data.keuze];
        [updatedKeuze[index], updatedKeuze[index - 1]] = [updatedKeuze[index - 1], updatedKeuze[index]];
        this.data.keuze = updatedKeuze;
      }
    },
    MuziekSelectChange (lied) {
      if (this.data.keuze.map(x => x.idMuziek).includes(lied.idMuziek)) {
        this.data.keuze = this.data.keuze.filter(x => x.idMuziek !== lied.idMuziek)
      } else if (this.data.keuze.length < this.maxKeuze) {
        const liedClone = this.CommonMixin_Clone(lied)
        this.data.keuze.push(liedClone)
      }
    },
    async SelectCurrent (lied) {
      if (!lied.loaded) {
        if (lied.idBlobMuziek) {
          lied.src = (await this.GetBlobMuziek(lied.idBlobMuziek))?.blobDataString ?? lied.src
        }

        lied.loaded = true
      }

      this.current = this.current === lied ? {} : lied
    },
    SelectMuziekType (value) {
      if (this.selectedMuziekType.includes(value)) {
        this.selectedMuziekType = this.selectedMuziekType.filter(x => x !== value)
      } else {
        this.selectedMuziekType.push(value)
      }
    },
    async Save () {
      this.$refs.form.validate()

      if (this.valid) {
        this.CommonMixin_Load(this.$options.name, true)
        const resp = await klantService.SaveUitvaartMuziek(this.data)

        if (resp && (resp.data || resp.data !== '')) {
          this.CommonMixin_Snackbar(this.textMixin.messages.saved, 'success')
        }

        this.CommonMixin_Load(this.$options.name, false)
      } else {
        this.CommonMixin_Snackbar(this.textMixin.messages.formInvalid, 'error')
      }
    },
    Title (lied) {
      return `${lied.titel}${lied.titel && lied.artiest ? ' - ' : ''}${lied.artiest}`
    }
  }
}
</script>

<style scoped>
.v-checkbox {
  margin: 0 !important;
  margin-bottom: -30px !important;
  margin-top: -5px !important;
}
</style>